import React from 'react';
import { NavLink, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import api, { clearSession, getRefreshToken, getUser } from '../services/api';
import Dashboard from './Dashboard';
import Requests from './Requests';
import Families from './Families';
import Users from './Users';
import Account from './Account';

export default function Shell() {
  const navigate = useNavigate();
  const user = getUser();

  const logout = async () => {
    try { await api.post('/api/auth/logout', { refreshToken: getRefreshToken() }); } catch (e) { /* iesim oricum */ }
    clearSession();
    navigate('/login', { replace: true });
  };

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand"><img src="/icon.svg" alt="" width="28" height="28" /> Buddies Manager</div>
        <nav className="nav">
          <NavLink to="/" end>Panou</NavLink>
          <NavLink to="/cereri">Cereri</NavLink>
          <NavLink to="/familii">Clienți</NavLink>
          <NavLink to="/utilizatori">Utilizatori</NavLink>
        </nav>
        <div className="topbar-user">
          <NavLink to="/cont" className="muted-link">{user?.email}</NavLink>
          <button className="btn btn-small" onClick={logout}>Deconectare</button>
        </div>
      </header>
      <main className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/cereri" element={<Requests />} />
          <Route path="/familii" element={<Families />} />
          <Route path="/utilizatori" element={<Users />} />
          <Route path="/cont" element={<Account />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
